// extracted by mini-css-extract-plugin
export default {"chartNavigation":"ChartNavigation_chartNavigation__n7P3Z"};